import type GoogleAutocomplete from '@Component/Google/Autocomplete/GoogleAutocomplete';

export default class GoogleAutocompleteUI {
    declare public readonly input: HTMLInputElement;
    declare public readonly clearButton: HTMLElement;

    constructor(public readonly el: GoogleAutocomplete) {
        this.input = this.el.autocomplete?.shadowRoot?.query('input') as HTMLInputElement;
        this.clearButton = this.el.autocomplete?.shadowRoot?.query('button.clear-button') as HTMLInputElement;
    }
}
